module.exports = __webpack_public_path__ + "img/step40_a_printer_power_remove_foam.bbcaac58.png";